import React from 'react';
import { storiesOf } from '@storybook/react';
import AdvancedFilterModal from './AdvancedFilterModal';
import { action } from '@storybook/addon-actions';

storiesOf('Advanced Search/Result Form/Modals', module)
  .add('AdvancedFilterModal', () => (
    <AdvancedFilterModal
      show
      onClose={() => null}
      onSave={action('submitAdvancedSearch')}
      filter={filter}
    />
  ));

const filter = {};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/AdvancedFilterModal.stories.jsx